import {bp} from './namespace.js';

$.extend(true, bp, {
  sessionstate: (function () {
    var _get_sessionstate = function () {
      $.ajax({
        dataType: 'json',
        url: '/data/dashboard/sessionstate/',
        data: {
          page_id: bp_page_id,
        },
        cache: false,
        async: true,
        success: function (result) {
          $(document).ready(function () {
            if (result.render_dashboard_menu) {
              $('#sidenav-links').replaceWith(result.dashboard_menu_html);
              $('#login-button').remove();
              $('#register-button').remove();
            }

            $('#bp-menu-button').on('click', function (ev) {
              ev.stopPropagation();
              $('#bp-sidenav').addClass('open');
              var overlay = $('#bp-sidenav-overlay');
              if (!overlay.hasClass('active')) {
                overlay.addClass('active');
              }
              document.body.style.cursor = 'pointer';
              document.body.addEventListener('click', _sidenavEventHandler);
              ad_listing_btn_handler();
            });

            $('.sessionstate-message').remove();

            if (result.render_su_message) {
              $('#request-messages').after(result.su_message_html);
            }
            if (result.render_cart_message) {
              $('#request-messages').after(result.cart_message_html);
            }
            if (result.render_messages) {
              $('#request-messages').after(result.messages_html);
            }
            $('#request-messages-wrapper').slideDown(100);

            if ('tracking_pixel' in result.statefull_snippets) {
              var tracking_pixels = result.statefull_snippets.tracking_pixel;
              for (var i = 0; i < tracking_pixels.length; i++) {
                $('body').append(tracking_pixels[i]);
              }
            }
          });
        },
      });
    };

    function _sidenavEventHandler(event) {
      var el = document.querySelector('#bp-sidenav');
      var style = window.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle;
      var isOpen = !(style.width === '0px');
      if (isOpen && event.target.id === 'for_sale_btn_listing_side_menu') {
        appState.listingManager().initForSaleAdvertFlow();
      }

      if (isOpen && event.target.id === 'for_rent_btn_listing_side_menu') {
        appState.listingManager().initForRentAdvertFlow();
      }

      if (isOpen && !event.target.classList.contains('sidenav')) {
        document.body.removeEventListener('click', _sidenavEventHandler);
        document.body.style.cursor = '';
        $('#bp-sidenav').removeClass('open');
        var overlay = $('#bp-sidenav-overlay');
        if (overlay.hasClass('active')) {
          overlay.removeClass('active');
        }
      }
    }

    function ad_listing_btn_handler() {
      $('#estate-offer-add-menu').on('click', function (ev) {
        ev.stopPropagation();
        $('#advert_listing_dropdown').toggle(300);
        $('#caret-icon').toggleClass('show-caret');
      });
    }

    function _set_menubutton_eventhandler() {
      $(document).ready(function () {
        $('#menu-button').on('click', function () {
          document.getElementById('bp-sidenav').style.width = '18em';

          var overlay = $('#bp-sidenav-overlay');
          if (!overlay.hasClass('active')) {
            overlay.addClass('active');
          }

          document.body.addEventListener('click', _sidenavEventHandler);
          ad_listing_btn_handler();
        });
      });
    }

    _get_sessionstate();
    _set_menubutton_eventhandler();

    return {
      get_sessionstate: function () {
        _get_sessionstate();
      },
    };
  })(),
});

export {bp};
